<template>
  <v-app :class="{ watermark: isStaging }">
    <v-toolbar app :clipped-left="clipped" color="primary" :class="{ watermarksm: isStaging }">
      <v-toolbar-side-icon
        @click.stop="drawer = !drawer"
        color="white--text"
      ></v-toolbar-side-icon>
      <div>
        <img src="@/assets/images/vonexLogo.png" height="54px" style="padding: 9px; margin: 6px 0 0" />
      </div>

      <v-spacer></v-spacer>
      <app-header></app-header>
    </v-toolbar>
    <v-content style="padding-top: 0">
      <v-flex grow>
        <app-sidebar v-if="hasDealer" :drawer="drawer"></app-sidebar>
      </v-flex>

      <v-container fluid pa-0 ma-0 class="pt-0">
        <!-- <AppStatus v-show="$route.name !== 'home'"></AppStatus> -->
        <router-view />
      </v-container>
      <app-note v-show="showNotes"></app-note>

      <v-footer :fixed="fixed" app>
        <span>&copy; {{ new Date().getFullYear() }} Copyright: vonex.com.au</span>
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import Header from './components/app-header'
import SideBar from './components/app-sidebar'
import Notification from './components/app-notification'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'
import AppStatus from './components/app-status'
import '@/assets/site.css'
import VuejsDialog from 'vuejs-dialog'
//import VuejsDialogMixin from "vuejs-dialog/vuejs-dialog-mixin.min.js" // only needed in custom components
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import MessageAlert from './components/MessageAlert'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import AppNote from './components/app-note'
import Title from './components/title.vue'
import feature from 'vue-feature-toggle'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import HomeView from '@/components/Home'

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyCBg8UqAObAnfP9WivnIaEhR99b03CzCvA' // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
})
const { mapGetters: mapOrderGetters } = createNamespacedHelpers(`orders`)
Vue.use(VuejsDialog)
Vue.use(Vue2Filters)
const PhoneNumber = require('awesome-phonenumber')
Vue.component('app-header', Header)
Vue.component('app-sidebar', SideBar)
Vue.component('app-notifications', Notification)

Vue.component('message-alert', MessageAlert)
Vue.component('date-picker', DatePicker)
Vue.component('v-title', Title)
Vue.component('app-note', AppNote)
Vue.component('AppStatus', AppStatus)

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('orderStatus', function (value) {
  switch (value) {
    case 0:
      return 'New'
    case 1:
      return 'In Progress'
    case 2:
      return 'Signed'
    case 3:
      return 'Completed'
    case 4:
      return 'Cancelled'
    case 5:
      return 'Rejected'
    default:
      return 'Unknown'
  }
})

// Vue.use(VeeValidate, {
//   events: "change",
// });

Vue.component('feature', feature)

export default {
  name: 'root',
  components: {
    HomeView
  },
  data() {
    return {
      clipped: true,
      fixed: true,
      title: 'Vonex',
      drawer: true,
      currentYear: new Date().getFullYear()
    }
  },
  computed: {
    ...mapOrderGetters(['hasDealer', 'isAdmin']),
    showNotes() {
      return ['Summary', 'OrderApprove'].indexOf(this.$route.name) < 0
    },
    isStaging() {
      return (
        process.env.NODE_ENV == 'staging' ||
        process.env.NODE_ENV == 'development'
      );
    },
  },
  mounted() {
    feature.visibility('feature-sms', () => {
      return this.isAdmin ? true : false
    })

    feature.visibility('feature-col', () => {
      return false
    })
    feature.visibility('feature-notifications', () => {
      return true
    })
  }
}
</script>

<style>
@import '../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-theme-balham {
  -webkit-box-shadow: 0px 6px 17px -11px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 6px 17px -11px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 6px 17px -11px rgba(0, 0, 0, 0.75);
  font-size: 14px !important;
}

.ag-header-row {
  background-color: #2f5578 !important;
  color: #fff !important;
  height: 100% !important;
}

.ag-header-cell::after {
  background-color: #fff !important;
}

.ag-header-cell:last-child::after {
  width: 0 !important;
}

.ag-header {
  height: 70px !important;
}

.ag-icon {
  color: #fff;
}

.ag-row,
.ag-paging-panel {
  height: 45px !important;
}

.ag-cell {
  line-height: 45px !important;
}

.ag-header-cell-text {
  font-size: 13px;
}

.ag-icon-first,
.ag-icon-previous,
.ag-icon-next,
.ag-icon-last {
  color: rgba(0, 0, 0, 0.54);
}

.v-datatable thead th {
  color: #fff !important;
}
.watermark {background: url('https://vonex.com.au/vonex/projects/watermark-blck.png') repeat !important;}
.watermarksm {background: url('https://vonex.com.au/vonex/projects/watermark-small.png') repeat !important;}
</style>
